import { faHeart as faHeartBlank } from "@fortawesome/free-regular-svg-icons";
import { faHeart, faShare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./RecentPosts.scss";
import { CopyToClipboard } from "react-copy-to-clipboard";

const RecentPosts = ({ posts, authUser, toast }) => {
  if (posts.length > 0) {
    return (
      <div className="recent-posts">
        <h2 className="recent-posts__title">Recent Posts</h2>
        <div className="recent-posts__container">
          {posts.map((data) => {
            console.log(data);
            return (
              <div className="post" style={{ width: "100%" }}>
                <div className="post-header">
                  <div className="post-user">
                    <span className="post-user-thumbnail">
                      <img
                        className="post-user-image"
                        src={data?.posts[0]?.avatar}
                        alt="user"
                      />
                    </span>
                    <div className="post-user-details">
                      <p className="post-user-name">
                        {data?.posts[0]?.userName}
                      </p>
                      <p className="post-user-date">
                        {new Date(data?.posts[0]?.date)
                          .toISOString()
                          .replace(/T.*/, "")
                          .split("-")
                          .reverse()
                          .join("-")}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="post-content">
                  {data?.posts[0].image &&
                  [".jpg", ".jpeg", ".png"].some((char) =>
                    data?.posts[0].image.endsWith(char)
                  ) ? (
                    <span className="post-content-image-container">
                      <img
                        className="w-full rounded-lg"
                        src={data?.posts[0].image}
                        alt=""
                      />
                    </span>
                  ) : null}
                  {data?.posts[0].image &&
                  ![".jpg", ".jpeg", ".png"].some((char) =>
                    data?.posts[0].image.endsWith(char)
                  ) ? (
                    <video
                      className="w-full rounded-lg"
                      controls
                      src={data?.posts[0].image}
                      alt=""
                    />
                  ) : null}
                  <p className="post-content-text">{data?.posts[0]?.text}</p>
                </div>
                <div className="post-content-stats">
                  <span className="post-content-like">
                    <FontAwesomeIcon
                      className="post-content-like-heart"
                      icon={
                        data.posts[0].likes.length > 0 ? faHeart : faHeartBlank
                      }
                    />
                    {data.posts[0].likes.length}
                  </span>
                  <CopyToClipboard
                    text={
                      process.env.REACT_APP_WEB_URL +
                      "/post/" +
                      data.posts[0]._id
                    }
                    onCopy={() => toast.success("Link copied to clipboard!")}
                  >
                    <span className="post-content-share">
                      <FontAwesomeIcon icon={faShare} />
                    </span>
                  </CopyToClipboard>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  } else {
    return (
      <div className="recent-posts">
        <h2 className="recent-posts__title">Recent Posts</h2>
        <div className="recent-posts__container">
          <h2 className="recent-posts__data">Nothing To Show Here!</h2>
        </div>
      </div>
    );
  }
};

export default RecentPosts;
